import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";
import { Star } from "lucide-react";

const testimonials = [
  { name: "Hirut Fikru", role: "IT Officer", quote: "I've seen many school systems during my career, but none have matched the balance of simplicity and power like eSchool.et. The platform is modern, responsive, and very reliable." },
  { name: "Fitsum Bekele", role: "School Owner", quote: "What stands out most about eSchool.et is the real-time data. As a School Owner, I can see student attendance, fee payments, and exam results at any time without waiting for manual reports." },
  { name: "Michael Alemu", role: "Head of IT", quote: "Our IT department was initially worried about training staff and rolling out a new system. But eSchool.et made the process surprisingly smooth. The interface is intuitive." },
  { name: "Rahel Kebede", role: "School Owner", quote: "Since we started using eSchool.et, parent communication has completely changed. Parents now receive instant updates about attendance, results, and events through the mobile app." },
  { name: "Yohannes Girma", role: "CTO", quote: "From a technology perspective, the system checks all the boxes: secure, fast, and designed for real-world challenges in Ethiopia. Solid 10/10 rating from me." },
  { name: "Samuel Getachew", role: "School Founder", quote: "Whether it's handling thousands of student records or generating detailed reports in seconds, the system performs flawlessly. The cloud-based design means our data is safe." },
  { name: "Meron Solomon", role: "HR Head", quote: "Teachers now record attendance on their tablets, parents check results directly on their phones, and we in HR can generate salary slips instantly. It has saved us countless hours." },
  { name: "Abebe Mekonnen", role: "School Owner", quote: "eSchool.et helped us reduce paperwork dramatically. Tasks that used to take days now take minutes. I would recommend it to any school looking for efficiency." },
  { name: "Hanna Tadesse", role: "School VP", quote: "We've tried different systems before, but none of them matched what eSchool.et offers. Parents are happy because they get instant notifications, and teachers say it saves them hours every week." },
];

const TestimonialsSection = () => (
  <section className="py-20 section-alt">
    <div className="container mx-auto px-4 lg:px-8">
      <SectionHeading
        badge="Testimonials & Reviews"
        title="Hear From Our Happy Clients"
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            className="bg-card rounded-2xl p-6 shadow-card"
          >
            <div className="flex items-center gap-1 mb-4">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-star fill-star" />)}
            </div>
            <p className="text-muted-foreground mb-4 leading-relaxed italic text-sm">"{t.quote}"</p>
            <div>
              <p className="font-heading font-semibold text-foreground text-sm">{t.name}</p>
              <p className="text-muted-foreground text-xs">{t.role}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
